import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 72BA6354-04A5-4BE9-A84C-843B9441164E
 * name crop-square
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crop-square.svg
 * tags
 */
export const CropSquareIcon = createSvgIcon(<><path d="M18,18H6V6H18M18,4H6A2,2 0 0,0 4,6V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V6C20,4.89 19.1,4 18,4Z" /></>, 'CropSquareIcon');
export default CropSquareIcon